import * as consts from "./consts";
import axios from "axios";
import {
  DefaultCharity,
  Charity,
  Query,
  SearchResult,
  Donation,
  Check,
} from "../types";

const createHTTPHeaders = async (getAccessTokenSilently: any) => {
  if (getAccessTokenSilently) {
    let token = await getAccessTokenSilently();
    let options = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    console.log(`Bearer ${token}`);
    return options;
  } else {
    return {};
  }
};

export const getCharity = async (ein: string): Promise<Charity> => {
  let response = await axios.get(
    `${consts.BLOB_URL}/v4-charities/${ein.padStart(9, "0")}.json?v=${Date.now()}`,
    {}
  );
  return {
    ...response.data,
    managed: { ...DefaultCharity.managed, ...response.data.managed },
  };
};

export const claimCharityByCheck = async (
  ein: string,
  checkDetails: {
    checkNumber1: string;
    checkAmount1: string;
    checkNumber2: string;
    checkAmount2: string;
  },
  getAccessTokenSilently: any
): Promise<boolean> => {
  let options = await createHTTPHeaders(getAccessTokenSilently);
  let response = await axios.post(
    `${consts.SERVICE_URL}/charities/${ein}/claim/check`,
    checkDetails,
    options
  );
  return response.data;
};

export const claimCharityByCode = async (
  ein: string,
  code: string,
  getAccessTokenSilently: any
): Promise<boolean> => {
  console.log({ ein, code });
  let options = await createHTTPHeaders(getAccessTokenSilently);
  let response = await axios.post(
    `${consts.SERVICE_URL}/charities/${ein}/claim/code/${code.trim()}`,
    {},
    options
  );
  return response.data;
};

export const requestCharityClaimCode = async (
  ein: string,
  getAccessTokenSilently: any
): Promise<boolean> => {
  let options = await createHTTPHeaders(getAccessTokenSilently);
  let response = await axios.post(
    `${consts.SERVICE_URL}/charities/${ein}/request/code`,
    {},
    options
  );
  return response.data;
};

export const checkManagerRole = async (
  ein: string,
  getAccessTokenSilently: any
): Promise<boolean> => {
  let options = await createHTTPHeaders(getAccessTokenSilently);
  let response = await axios.post(
    `${consts.SERVICE_URL}/charities/${ein}/ismanager`,
    {},
    options
  );
  return response.data;
};

export const getChecks = async (
  ein: string,
  getAccessTokenSilently: any
): Promise<Check[]> => {
  let options = await createHTTPHeaders(getAccessTokenSilently);
  let response = await axios.get(
    `${consts.SERVICE_URL}/charities/${ein}/checks`,
    options
  );
  return response.data;
};

export const uploadAsset = async (
  file: File,
  fileName: string
): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("url", `${consts.ASSET_URL}/v4-charity-images/${fileName}`);
  let response = await axios.post(`${consts.SERVICE_URL}/assets`, formData, {
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const saveCharity = async (charity: Charity): Promise<Charity> => {
  if (charity.managed.displayBannerFile) {
    charity.managed.displayBannerUrl = await uploadAsset(
      charity.managed.displayBannerFile,
      `${charity.ein}_banner.jpg`
    );
  }
  if (charity.managed.displayLogoFile) {
    charity.managed.displayLogoUrl = await uploadAsset(
      charity.managed.displayLogoFile,
      `${charity.ein}_logo.jpg`
    );
  }
  let response = await axios.post(
    `${consts.SERVICE_URL}/charities/`,
    {
      ...charity,
      managed: {
        ...charity.managed,
        displayBannerFile: null,
        displayLogoFile: null,
      },
    },
    {}
  );
  return response.data;
};

export const getDonationByDate = async (
  startDate: Date | null,
  endDate: Date | null,
  ein: string
): Promise<Donation[]> => {
  let queryParameters = "";
  if (startDate && endDate) {
    queryParameters = `?startDate=${
      startDate.toISOString().split("T")[0]
    }&endDate=${endDate.toISOString().split("T")[0]}&ein=${ein}`;
  }
  let response = await axios.get(
    `${consts.SERVICE_URL}/donations/${queryParameters}`,
    {}
  );
  return response.data;
};

export const getDonations = async (
  ein: string,
  checkNumber: string
): Promise<Donation[]> => {
  let response = await axios.get(
    `${consts.SERVICE_URL}/donations/?ein=${ein}&checkNumber=${checkNumber}`,
    {}
  );
  return response.data;
};
